import { useEffect, useRef } from 'react';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { useConfiguration } from '~/context/common/StaticContext';
import useClosestVehicle from './selectors/useClosestVehicle';
import useTestDriveCenter from './useTestDriveCenter';

export default function useTrackPerfectMatchViewed() {
  const { enableNewCarConfiguratorV2 } = useConfiguration();
  const closestVehicle = useClosestVehicle();
  const testDriveCenter = useTestDriveCenter();
  const trackEvent = useTrackEvent();
  const trackedVehicleId = useRef<number | null>(null);

  const vehicleId =
    enableNewCarConfiguratorV2 && !testDriveCenter.isActive
      ? closestVehicle?.vehicleId ?? null
      : null;

  useEffect(() => {
    if (!vehicleId || trackedVehicleId.current === vehicleId) {
      return;
    }

    trackedVehicleId.current = vehicleId;
    trackEvent('New Cars', {
      action: 'viewed',
      level: 'Options',
      section: 'Sticky Footer',
      text: 'View Perfect Match',
      vehicleId
    });
  }, [trackEvent, vehicleId]);
}
